import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ArticleAccessRuleShortModel, ArticlesAccessModel } from 'Pages/knowledge'
import { Callback } from 'Src/types/utilTypes'

export type AccessState = {
	user?: number
	data?: ArticlesAccessModel[]
}

export const accessInitialState: AccessState = {
	user: null,
	data: null,
}

export namespace accessNS {
	export type getArticlesAccess = PayloadAction<number | undefined>
	export type setArticlesAccess = PayloadAction<Array<ArticlesAccessModel>>
	export type createArticleAccess = PayloadAction<{
		data: ArticleAccessRuleShortModel
		callback?: Callback
	}>
	export type deleteArticleAccess = PayloadAction<{ id: number; callback?: Callback }>
}

export const accessSlice = createSlice({
	name: 'access',
	initialState: accessInitialState,
	reducers: {
		getArticlesAccess: (state, action: accessNS.getArticlesAccess) => {
			state.user = action.payload
		},
		setArticlesAccess: (state, action: accessNS.setArticlesAccess) => {
			state.data = action.payload
		},
		createArticleAccess: (state, action: accessNS.createArticleAccess) => {},
		deleteArticleAccess: (state, action: accessNS.deleteArticleAccess) => {},
	},
})
